<template>
  <GuidesSkeletonLoader
    v-if="pageLoading"
    items-per-row="two"
    :number-of-cards="4"
  />
  <div v-else>
    <GuidesTabs
      :tabs="policyGuideItems"
      items-per-row="two"
      @submit="submit"
    />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useSettingsGuides } from '@/stores/settings/guides';
import GuidesTabs from '@/components/settings/components/GuidesTabs.vue';
import GuidesSkeletonLoader from '@/components/shared/SkeletonLoaders/settings/GuidesSkeletonLoader.vue';

const appLoadingStore = useAppLoading();
const { pageLoading } = storeToRefs(appLoadingStore);

const settingsGuidesStore = useSettingsGuides();
const { policyGuideItems } = storeToRefs(settingsGuidesStore);
const { loadGuides, submit } = settingsGuidesStore;

onMounted(() => {
  loadGuides();
});
</script>
